/* eslint-disable  */


const saveLocalProject = (id, projectData) => {
	localStorage.setItem(id, projectData.replace(/%/g, "$@$@"));
	return projectData;
};

const getProject = (id) => {
	if (localStorage.getItem(id) == null) {
		return null;
	}
	var data = localStorage.getItem(id).replace(/(\$\@\$\@)/g, "%");
	return JSON.parse(data);
}
const clearStore = () => {
	console.log("clear store");
	localStorage.clear();
}


export { saveLocalProject, getProject, clearStore };
